import { render, staticRenderFns } from "./xdyq.vue?vue&type=template&id=c16680e0&scoped=true"
import script from "./xdyq.vue?vue&type=script&lang=js"
export * from "./xdyq.vue?vue&type=script&lang=js"
import style0 from "./xdyq.vue?vue&type=style&index=0&id=c16680e0&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16680e0",
  null
  
)

export default component.exports